// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-container {
  border-bottom: 1px solid #E7E7E7;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.header-container .loader-icon {
  animation: spin 1000ms linear infinite;
}

.faq-modal .modal-container {
  width: 600px !important;
  height: 600px !important;
}`, "",{"version":3,"sources":["webpack://./src/routes/event-create/components/header/style.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;AACF;AACE;EACE;IACI,uBAAA;EACN;EACE;IACI,yBAAA;EACN;AACF;AACE;EACE,sCAAA;AACJ;;AAGA;EACE,uBAAA;EACA,wBAAA;AAAF","sourcesContent":[".header-container {\n  border-bottom: 1px solid theme('colors.grey-30');\n\n  @keyframes spin {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n  }\n  .loader-icon {\n    animation: spin 1000ms linear infinite;\n  }\n}\n\n.faq-modal .modal-container {\n  width: 600px !important;\n  height: 600px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
